// !TODO add `space` array for shadowing/extending reference
// Can't find default values

const spacing = {
  headerHeight: [48, null, 80],
  landingSectionSpacing: [5, null, "calc(3rem + 4vw)", null, null, 5],
  markdownElementYSpacing: {
    mt: 0,
    mb: ["calc(1rem + 1vw)", null, null, null, 4]
  },
  showItemSpacing: [3, null, 4],
  showDateBoxSize: [72, null, 90]
}

export default spacing
